<template>
  <div class="header">
    <div class="topbg">
      <div class="content">
        <div class="logo">
          <img src="@/assets/images/bamei/logo.png">
        </div>
        <div class="right">
          <div class="top">
            <div class="language">
              <span
                :class="{'on' : Selectlanguage=='chinese'}"
                @click="goto('chinese')"
              >
                中文
              </span>
              <span
                :class="{'on' : Selectlanguage=='English'}"
                @click="goto('English')"
              >
                English
              </span>
            </div>
            
            <HeaderBar
              v-if="!isEnglish"
              :width="pageWidth"
              :bgColor="bgColor"
              :fontWeight="fontWeight"
              :registerTextColor="registerTextColor"
              :loginTextColor="loginTextColor"
            />
            <div class="top-nav-left">坝美今日天气：{{ `${weatherData.weather || ''} ${weatherData.temperature || ''}℃` }}</div>
          </div>
          <div class="nav" v-if="!isEnglish">
            <div
              class="tab-item"
              v-for="item in tabList"
              :key="item.value"
              :class="{on: item.routeName === value}"
            >
              <span @click="onTabClick(item)"> {{ item.label }} </span>
              <em
                v-if="item.routeName === value"
                :style="{ width: item.label.length <= 2 ? '48px' : '' }"
              >
                <img
                  v-if="item.label.length <= 2"
                  src="@/assets/images/bamei/nav_on.png"
                >
                <img
                  v-else
                  src="@/assets/images/bamei/nav_on_long.png"
                >
              </em>
              <div
                v-if="item.routeName === value && showChild"
                class="child-bamei"
              >
                <span 
                  v-for="(sitem, sIndex) in item.children"
                  :key="sitem.value"
                  :class="{on: childIndex === sIndex}"
                  @click="onTabClick(sitem, sIndex)"
                >
                  {{ sitem.label }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import HeaderBar from '@/components/headerBar';
import api from '@/api/api';
import { apiGet } from '@/fetch/api';

export default {
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: 'introduce',
    },
    isEnglish:{
      type: Boolean,
      default: false
    },
    Selectlanguage:{
      type: String,
      default: 'chinese',
    },
  },
  components: {
    HeaderBar,
  },
  data() {
    return {
      current: '',
      showLoginModel: false,
      pageWidth: 166,
      bgColor: '',
      fontWeight: 'bold',
      registerTextColor: '#126C42',
      loginTextColor: '#333',
      weatherData: {},
      showChild: false,
      childIndex: undefined,
    };
  },
  computed: {
    ...mapState(['login', 'userInfo', 'm_id', ''])
  },
  created () {
    this.getWeather();
  },
  methods: {
    onTabClick(data, sIndex) {
      if (data.linkUrl === this.value) {
        return;
      }
      this.showChild = data.children && data.children.length > 0
      if (sIndex >= 0) {
        this.childIndex = sIndex;
      }
      this.$emit('change', data);
    },
    loginChange(bool, isLoginRegister) {
      this.$parent.loginChange(bool, isLoginRegister)
    },
    goto(type){
      if (type === 'chinese'){
        this.$router.push('/index?m_id='+(localStorage.getItem('m_id') || this.$route.query.m_id));
        localStorage.setItem('selectValue', 'bameiHomePage');
      }
      if (type === 'English'){
        localStorage.setItem('news_title', 'English');
        this.$router.push({
          path: '/introduce',
          query: {
            pid: 1494,
            menuId: 614,
            m_id: this.$route.query.m_id || 1758,
          }
        })
      }
      this.$emit('lang', type);
    },
    // 获取天气
    getWeather() {
      let customUrl = api.main.getUsePage;
      apiGet(customUrl, {
        pageType: 'mianPage',
        useRange: 'pcWebsite',
      }).then(res => {
        const data = JSON.parse(res.data.content);
        // 天气数据
        const weatherList = data.filter(p => p.category === 'weather')
        console.log({ weatherList })
        this.weatherData = weatherList.length ? weatherList[0].data : {};
      });
    },
  }, 
}
</script>
<style scoped lang="scss">
.header {
  .topbg {
    width: 100%;
    background:#5BB692 ;
    height: 108px;
    position: absolute;;
    z-index: 100;
    top: 0;
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    position: relative;
    z-index: 100;
    .logo {
      width: 144px;
      height: 179px;
      margin-right: 20px;
      img {
        width: 100%;
      }
    }
    .right {
      width: 100%;
      height: 108px;
      .top {
        position: relative;
        width: 100%;
        height: 42px;
        line-height: 42px;
        text-align: right;
        color: #333;

        display: flex;
        flex-direction: row-reverse;
        .header-top-bar {
          width: 166px; 
          height: auto;
        }  
        .login {
          cursor: pointer;
        } 
        .regsiter {
          cursor: pointer;
          color:#126c42 ;
          padding-left: 20px;
        }
        .language {
          clear: both;
          margin-top: 10px;
          span {
            display: block;
            float: left;
            width: 54px;
            cursor: pointer;
            height: 22px;
            text-align: center;
            line-height: 22px;
            border: 1px solid #126c42;
            color: #333;
          }
          .on {
            color: #fff;
            background:#126c42;
          }
        }
        .top-nav-left {
          font-size: 12px;
          color: #333;
          font-weight: bold;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .nav {
      display: flex;
      .tab-item {
        width: 100px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
        cursor: pointer;
        em {
          display: block;
          height: 7px;
          margin: 0 auto;
          margin-top: 10px;
        }
        .child-bamei {
          position: fixed;
          z-index: 5;
          width: 100px;
          span {
            display: block;
            height: 36px;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            color: #fff;
            font-size: 16px;
            background: #26795c;
            margin-bottom: 5px;
            &:hover {
              background: #51ba89;
            }
          }
          .on {
            background: #51ba89;
          }
        }
      }
      .on {
        color: #126c42;
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bameiNew/components/header.vue